import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { data, extract } from '../../../util/util';
import { toast } from 'react-toastify';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import { FinField, FinTextarea } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';

export default function CadastroEventoParticipanteHotelConvite({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const history = useHistory();
    const idioma = getIdiomaCodigo();

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //o back decide a etapa (proximoStep). Se esta tela ('hotel') não é a etapa atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'hotel') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            setDados(dadosRecebidos);
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const validar = () => {
        return true;
    };

    const salvar = () => {
        var idEvento = dados.evento.id;

        if (!validar()) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/escolhaHotel/' + id,
            token: token,
            data: {
                hotelobservacao: dados.hotelobservacao ?? null,
            }
        })
            .then(function (response) {
                toast.success(getText('dadosSalvosSucesso'));
                //o back resolve a próxima etapa com o estado fresco pós-save (overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: idEvento, contrato, setLoading: setIsLoading });
            })
            .catch(function () {
                toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">{getText('hospedagem')}</h1></div>
                </div>

                {!isLoading && !isError && dados?.evento?.id && (
                    <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                        <div className="fin-pp__card" style={{ padding: 24, marginBottom: 16 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 16 }}>
                                <h2 className="fin-pp__cphead-title">{getText('hospedagem')}</h2>
                            </div>
                            <p style={{ color: 'var(--fin-tx)', marginBottom: 12 }}>
                                {dados.hotelnome && <strong>{dados.hotelnome}</strong>}
                                {dados.hotellogradouro &&
                                    <><br />
                                        <strong>{getText('endereco')} </strong> {dados.hotellogradouro}, {dados.hotelbairro ?? ""}, {dados.hotelmunicipio?.nome ?? ""} - {dados.hotelmunicipio?.uf ?? ""}
                                    </>
                                }
                                {dados.hoteldatacheckin &&
                                    <><br />
                                        <strong>{getText('checkin')} </strong> {data(dados.hoteldatacheckin)} {dados.hotelhoracheckin ?? ""}
                                    </>
                                }
                                {dados.hoteldatacheckout &&
                                    <><br />
                                        <strong>{getText('checkout')} </strong> {data(dados.hoteldatacheckout)} {dados.hotelhoracheckout ?? ""}
                                    </>
                                }
                                {dados.hoteltipoquarto &&
                                    <><br />
                                        <strong>{getText('tipoApartamento')} </strong> {dados.hoteltipoquarto}
                                    </>
                                }
                                {!dados.hotelnome &&
                                    <><br />
                                        <strong>{getText('emBreveMaisInformacoes')}</strong>
                                    </>
                                }
                            </p>
                            {!['chiesi'].includes((dados.evento?.cliente?.modelo ?? "master")) ?
                                <>
                                    <p style={{ color: 'var(--fin-tx)', marginBottom: 8 }}>{getText('patrocinioDisponivel')}</p>
                                    <p style={{ color: 'var(--fin-tx)', marginBottom: 12 }}>{getText('naoUtilizarHospedagem')}</p>
                                    <div className="fin-pp__filters">
                                        <FinField label={getText('observacaoPlaceholder')} full>
                                            <FinTextarea
                                                placeholder={getText('observacaoPlaceholder')}
                                                value={dados.hotelobservacao ?? ""}
                                                onChange={e => setDados({ ...dados, ...{ "hotelobservacao": e.target.value } })}
                                            />
                                        </FinField>
                                    </div>
                                </> : null
                            }
                        </div>

                        <div className="fin-pp__card" style={{ padding: 16 }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <button
                                    type="submit"
                                    className="fin-pp__btn fin-pp__btn--primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />{getText('salvando')}</>
                                    ) : (
                                        <><FaSave size={16} style={{ marginRight: 6 }} />{getText('salvar')}</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        </ErpTemplate>
    );
}
